import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=5e118008"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports